<template>
  <div>
    <Head title="Create Stream" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/streams">Streams</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <div class="flex ml-8 mr-8 mt-8 mb-2 p-4 mb-4 text-sm text-blue-800 border border-blue-300 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800" role="alert">
        <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
        <span class="sr-only">Info</span>
        <div>
          <span class="font-medium">Important note!</span> Stream name must be same as the stream pushed to the media server.
        </div>
      </div>
      <stream-form
        :form="form"
        :projects="projects"
        :can-select-project="canSelectProject"
        submit-button-text="Update Stream"
        :submit="store"
      />
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import StreamForm from '@/Pages/Streams/StreamForm.vue'

export default {
  components: {
    Head,
    Link,
    StreamForm,
  },
  layout: Layout,
  props: {
    stream: Object,
    projects: Array,
    loggedUser: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        color: null,
        title: null,
        project_id: 48,
        organization_id: this.loggedUser.organization_id,
        orientation: 'landscape',
      }),
    }
  },
  computed: {
    canSelectProject() {
      return this.loggedUser.type === 'ADMIN' ||
        (this.loggedUser.type === 'PARTNER' && this.loggedUser.type === 'TECHNICIAN')
    },
  },
  mounted() {
    console.log(this.projects);
    console.log(this.loggedUser.project_id);
  },
  methods: {
    store() {
      this.form.post('/streams')
    },
  },
}
</script>
